function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M26 26.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3M19 0c10.493 0 19 8.507 19 19s-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0zm0 2C9.626 2 2 9.626 2 19c0 9.374 7.626 17 17 17 9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17zm7 16.5c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm-14 0c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm0 2c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm8.375-9.78a1 1 0 011.406.155l3.7 4.625H26a1 1 0 110 2h-1c-.303 0-.591-.138-.781-.375l-3.375-4.22-3.462 2.77L19.8 18.9c.13.174.2.384.2.6v5a1 1 0 11-2 0v-4.665L15.2 16.1a1 1 0 01.175-1.381zM25 7.5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z",
  id: "icon-bicycle_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "icon-bicycle_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-bicycle_svg__a"
})), React.createElement("use", {
  xlinkHref: "#icon-bicycle_svg__a"
}), React.createElement("g", {
  mask: "url(#icon-bicycle_svg__b)"
}, React.createElement("path", {
  d: "M0 0h38v38H0z"
})));

var SvgIconBicycle = function SvgIconBicycle(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconBicycle;